import React from "react";
import NavBar from "../components/NavBar";
import HeroImage2 from "../components/HeroImage2";
import SystemDevelopmentContent from "../components/SystemDevelopmentContent";
import Footer from "../components/Footer";

const SystemDevelopment = () => {
  return (
    <div>
      <NavBar />
      {/* <HeroImage2
        bgImage="hero-img-projects"
        heading="SYSTEM DEVELOPMENT"
        text="Engineered for excellence."
      /> */}
      <div style={{ paddingTop: "100px" }}>
        <SystemDevelopmentContent />
      </div>
      
      {/* <Footer /> */}
    </div>
  );
};

export default SystemDevelopment;
